import {ApckPortletCardPanel} from "../portlet";

export const ApckPortletUnfixedCounter = /*#__PURE__*/ ApckPortletCardPanel.extend({
    props: {
        ctype: {
            type: String,
            default: "unfixedcounterportlet"
        },
        title: {
            type: String,
            default: "Unfixed Counter"
        },
        size: {
            type: String,
            default: "lg"
        },
        description: {
            type: String,
            default: "Table showing the amounts and types of unfixed vulns"
        },
        src: {
            type: String,
            default: "/unfixedvulnscounter"
        },
    },
});
